import React from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

function CustomModal(props) {
    const {
        show,
        onHide,
        title,
        titleDetails,
        dialogClassName,
        additionalContentClassName,
        centered,
        children,
        footer,
    } = props;

    return (
        <Modal
            show={show}
            onHide={() => onHide(false)}
            size="lg"
            contentClassName={`d-flex justify-content-center align-items-center border-0 ${additionalContentClassName ?? ""}`}
            backdrop="static"
            dialogClassName={dialogClassName}
            centered={centered}
            className="d-flex flex-wrap justify-content-center"
            keyboard={false}
        >
            <Modal.Header className="w-100" closeButton>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <h5>{title}</h5>{titleDetails}
                        </Col>
                    </Row>
                </Container>
            </Modal.Header>
            <Modal.Body className="w-100 h-100" style={{maxHeight: "72vh", overflowY: "scroll"}}>
                {children}
            </Modal.Body>
            <Modal.Footer className="w-100">
                {footer}
            </Modal.Footer>
        </Modal>
    );
}

CustomModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    titleDetails: PropTypes.string,
    dialogClassName: PropTypes.string,
    additionalContentClassName: PropTypes.string,
    centered: PropTypes.bool,
};

CustomModal.defaultProps = {
    dialogClassName: null,
    centered: false,
};

export default CustomModal;
